import React from 'react';
import person1 from '../assets/images/person1.png';
import person2 from '../assets/images/person2.png';
import person3 from '../assets/images/person3.png';


export const avatarData = [
  {
    id: 1,
    name: 'male',
    prefix: 'm',
    image: person1,
    options: [
      {
        id: 'faceshape',
        question: <>How would you describe their <b>face shape?</b></>,
        values: [
          { value: 'v', text: 'V Shaped' },
          { value: 'square', text: 'Square' },
          { value: 'round', text: 'Round' },
          { value: 'oval', text: 'Oval' },
          { value: 'diamond', text: 'Diamond Shaped' },
          { value: 'long', text: 'Long' },
        ],
      },
      {
        id: 'skintone',
        question: <>How would you describe their <b>skintone</b>?</>,
        values: [
          { value: 'light', text: 'Light' },
          { value: 'honey', text: 'Honey' },
          { value: 'olive', text: 'Olive' },
          { value: 'tanned', text: 'Tanned' },
          { value: 'almond', text: 'Almond' },
          { value: 'dark', text: 'Dark' },
        ],
      },
      {
        id: 'nose',
        question: <>How would you describe the shape of their <strong>nose</strong>?</>,
        values: [
          { value: 'bulbous', text: 'Bulbous'},
          { value: 'hawk', text: 'Hawk'},
          { value: 'button', text: 'Button'},
          { value: 'straight', text: 'Straight'},
          { value: 'widebase', text: 'Wide base'},
          { value: 'turnedup', text: 'Turned Up'},
        ],
      },
      {
        id: 'beard',
        question: <>How would you describe their <strong>beard</strong>?</>,
        values: [
          { value: 'scruff', text: 'Scruff'},
          { value: 'long', text: 'Long'},
          { value: 'medium', text: 'Medium'},
          { value: 'tailored', text: 'Tailored'},
          { value: 'stiletto', text: 'Stiletto'},
          { value: 'balbo', text: 'Balbo'},
          { value: 'shortboxed', text: 'Sort Boxed'},
          { value: 'stubble', text: 'Stubble'},
        ],
      },
      {
        id: 'hairstyle',
        question: <>How would you describe their <strong>hair style</strong>?</>,
        values: [
          { value: 'buzz', text: 'Buzz'},
          { value: 'pompadour', text: 'Pompadour'},
          { value: 'slickedback', text: 'Slicked Back'},
          { value: 'suave', text: 'Suave'},
          { value: 'quiff', text: 'Quiff'},
          { value: 'sideswept', text: 'Side Swept'},
          { value: 'curly', text: 'Curly'},
        ],
      },
      {
        id: 'eyebrowshape',
        question: <>What is the shape of their <strong>eyebrows</strong>?</>,
        values: [
          { value: 's', text: 'S-shaped'},
          { value: 'hardangled', text: 'Hard-angled'},
          { value: 'softangled', text: 'Soft-angled'},
          { value: 'straight', text: 'Straight'},
          { value: 'rounded', text: 'Rounded'},
          { value: 'upward', text: 'Upward'},
        ],
      },
      {
        id: 'haircolour',
        question: <>What is their <strong>hair color</strong>?</>,
        values: [
          { value: 'darkbrown', text: 'Dark Brown'},
          { value: 'brown', text: 'Brown'},
          { value: 'auburn', text: 'Auburn'},
          { value: 'chestnut', text: 'Chestnut'},
          { value: 'hazel', text: 'Hazel'},
          { value: 'red', text: 'Red'},
          { value: 'blonde', text: 'Blonde'},
          { value: 'black', text: 'Black'},
        ],
      },
      {
        id: 'lipshape',
        question: <>How would you describe the shape of their <strong>lips</strong>?</>,
        values: [
          { value: 'thin', text: 'Thin'},
          { value: 'oval', text: 'Oval'},
          { value: 'downturned', text: 'Down Turned'},
          { value: 'small', text: 'Small'},
          { value: 'largefull', text: 'Large Full'},
          { value: 'sharp', text: 'Sharp'},
        ],
      },
      {
        id: 'eyeshape',
        question: <>How would you describe their <strong>eye shape</strong>?</>,
        values: [
          { value: 'almond', text: 'Almond'},
          { value: 'upturned', text: 'Up Turned'},
          { value: 'hooded', text: 'Hooded'},
          { value: 'round', text: 'Round'},
          { value: 'monolid', text: 'Monolid'},
          { value: 'downturned', text: 'Down Turned'},
        ],
      },
      {
        id: 'eyecolor',
        question: <>What is their <strong>eye color</strong>?</>,
        values: [
          { value: 'blue', text: 'Blue'},
          { value: 'darkbrown', text: 'Dark Brown'},
          { value: 'brown', text: 'Brown'},
          { value: 'hazel', text: 'Hazel'},
          { value: 'amber', text: 'Amber'},
          { value: 'grey', text: 'Grey'},
        ],
      },
    ]
  },
  {
    id: 2,
    name: 'female',
    prefix: 'f',
    image: person3,
    options: [
      {
        id: 'faceshape',
        question: <>How would you describe their <b>face shape?</b></>,
        values: [
          { value: 'v', text: 'V Shaped' },
          { value: 'square', text: 'Square' },
          { value: 'round', text: 'Round' },
          { value: 'oval', text: 'Oval' },
          { value: 'diamond', text: 'Diamond Shaped' },
          { value: 'long', text: 'Long' },
        ],
      },
      {
        id: 'skintone',
        question: <>How would you describe their <b>skintone</b>?</>,
        values: [
          { value: 'light', text: 'Light' },
          { value: 'honey', text: 'Honey' },
          { value: 'olive', text: 'Olive' },
          { value: 'tanned', text: 'Tanned' },
          { value: 'almond', text: 'Almond' },
          { value: 'dark', text: 'Dark' },
        ],
      },
      {
        id: 'nose',
        question: <>How would you describe the shape of their <strong>nose</strong>?</>,
        values: [
          { value: 'bulbous', text: 'Bulbous'},
          { value: 'hawk', text: 'Hawk'},
          { value: 'button', text: 'Button'},
          { value: 'straight', text: 'Straight'},
          { value: 'widebase', text: 'Wide base'},
          { value: 'turnedup', text: 'Turned Up'},
        ],
      },
      {
        id: 'freckles',
        question: <>Do they have <strong>freckles</strong>?</>,
        values: [
          { value: 'yes', text: 'Yes'},
          { value: 'no', text: 'No'},
        ],
      },
      {
        id: 'hairlength',
        question: <>How would you describe the <strong>length of their hair</strong>?</>,
        values: [
          { value: 'short', text: 'Short'},
          { value: 'medium', text: 'Medium'},
          { value: 'long', text: 'Long'},
        ],
      },
      {
        id: 'hairstyle',
        question: <>How would you describe their <strong>hair style</strong>?</>,
        values: [
          { value: 'tightcurls', text: 'Tight Curls'},
          { value: 'straight', text: 'Straight'},
          { value: 'frizzy', text: 'Frizzy'},
          { value: 'curly', text: 'Curly'},
          { value: 'wavy', text: 'Wavy'},
        ],
      },
      {
        id: 'eyebrowshape',
        question: <>What is the shape of their <strong>eyebrows</strong>?</>,
        values: [
          { value: 's', text: 'S-shaped'},
          { value: 'hardangled', text: 'Hard-angled'},
          { value: 'softangled', text: 'Soft-angled'},
          { value: 'straight', text: 'Straight'},
          { value: 'rounded', text: 'Rounded'},
          { value: 'upward', text: 'Upward'},
        ],
      },
      {
        id: 'haircolour',
        question: <>What is their <strong>hair color</strong>?</>,
        values: [
          { value: 'darkbrown', text: 'Dark Brown'},
          { value: 'brown', text: 'Brown'},
          { value: 'auburn', text: 'Auburn'},
          { value: 'chestnut', text: 'Chestnut'},
          { value: 'hazel', text: 'Hazel'},
          { value: 'red', text: 'Red'},
          { value: 'blonde', text: 'Blonde'},
          { value: 'black', text: 'Black'},
        ],
      },
      {
        id: 'lipshape',
        question: <>How would you describe the shape of their <strong>lips</strong>?</>,
        values: [
          { value: 'thin', text: 'Thin'},
          { value: 'oval', text: 'Oval'},
          { value: 'downturned', text: 'Down Turned'},
          { value: 'small', text: 'Small'},
          { value: 'largefull', text: 'Large Full'},
          { value: 'sharp', text: 'Sharp'},
        ],
      },
      {
        id: 'glasses',
        question: <>How would you describe the shape of their <strong>glasses</strong>?</>,
        values: [
          { value: 'circular', text: 'Circular'},
          { value: 'rectangular', text: 'Rectangular'},
          { value: 'oversized', text: 'Oversized'},
          { value: 'flattop', text: 'Flat Top'},
          { value: 'cateye', text: 'Cat Eye'},
          { value: 'oval', text: 'Oval'},
        ],
      },
      {
        id: 'eyeshape',
        question: <>How would you describe their <strong>eye shape</strong>?</>,
        values: [
          { value: 'almond', text: 'Almond'},
          { value: 'upturned', text: 'Up Turned'},
          { value: 'hooded', text: 'Hooded'},
          { value: 'round', text: 'Round'},
          { value: 'monolid', text: 'Monolid'},
          { value: 'downturned', text: 'Down Turned'},
        ],
      },
      {
        id: 'eyecolor',
        question: <>What is their <strong>eye color</strong>?</>,
        values: [
          { value: 'blue', text: 'Blue'},
          { value: 'darkbrown', text: 'Dark Brown'},
          { value: 'brown', text: 'Brown'},
          { value: 'hazel', text: 'Hazel'},
          { value: 'amber', text: 'Amber'},
          { value: 'grey', text: 'Grey'},
        ],
      },
    ]
  },
  {
    id: 3,
    name: 'old-male',
    prefix: 'om',
    image: person2,
    options: [
      {
        id: 'faceshape',
        question: <>How would you describe their <b>face shape?</b></>,
        values: [
          { value: 'v', text: 'V Shaped' },
          { value: 'square', text: 'Square' },
          { value: 'round', text: 'Round' },
          { value: 'oval', text: 'Oval' },
          { value: 'diamond', text: 'Diamond Shaped' },
          { value: 'long', text: 'Long' },
        ],
      },
      {
        id: 'skintone',
        question: <>How would you describe their <b>skintone</b>?</>,
        values: [
          { value: 'light', text: 'Light' },
          { value: 'honey', text: 'Honey' },
          { value: 'olive', text: 'Olive' },
          { value: 'tanned', text: 'Tanned' },
          { value: 'almond', text: 'Almond' },
          { value: 'dark', text: 'Dark' },
        ],
      },
      {
        id: 'nose',
        question: <>How would you describe the shape of their <strong>nose</strong>?</>,
        values: [
          { value: 'bulbous', text: 'Bulbous'},
          { value: 'hawk', text: 'Hawk'},
          { value: 'button', text: 'Button'},
          { value: 'straight', text: 'Straight'},
          { value: 'widebase', text: 'Wide base'},
          { value: 'turnedup', text: 'Turned Up'},
        ],
      },
      {
        id: 'wrinkles',
        question: <>How would you describe their <strong>wrinkles</strong>?</>,
        values: [
          { value: 'none', text: 'None'},
          { value: 'weathered', text: 'Weathered'},
          { value: 'smilelines', text: 'Smile Lines'},
          { value: 'heavy', text: 'Heavy'},
          { value: 'fine', text: 'Fine'},
          { value: 'gravitationalfold', text: 'Gravitational Fold'},
        ],
      },
      {
        id: 'beard',
        question: <>How would you describe their <strong>beard</strong>?</>,
        values: [
          { value: 'scruff', text: 'Scruff'},
          { value: 'long', text: 'Long'},
          { value: 'medium', text: 'Medium'},
          { value: 'tailored', text: 'Tailored'},
          { value: 'stiletto', text: 'Stiletto'},
          { value: 'shortboxed', text: 'Sort Boxed'},
          { value: 'stubble', text: 'Stubble'},
        ],
      },
      {
        id: 'hairstyle',
        question: <>How would you describe their <strong>hair style</strong>?</>,
        values: [
          { value: 'bald', text: 'Bald'},
          { value: 'loose', text: 'Loose'},
          { value: 'wavy', text: 'Wavy'},
          { value: 'slickedback', text: 'Slicked Back'},
          { value: 'combover', text: 'Comb Over'},
          { value: 'receding', text: 'Receding'},
          { value: 'buzz', text: 'Buzz'},
          { value: 'suave', text: 'Suave'},
        ],
      },
      {
        id: 'eyebrowshape',
        question: <>What is the shape of their <strong>eyebrows</strong>?</>,
        values: [
          { value: 's', text: 'S-shaped'},
          { value: 'hardangled', text: 'Hard-angled'},
          { value: 'softangled', text: 'Soft-angled'},
          { value: 'straight', text: 'Straight'},
          { value: 'rounded', text: 'Rounded'},
          { value: 'upward', text: 'Upward'},
        ],
      },
      {
        id: 'haircolour',
        question: <>What is their <strong>hair color</strong>?</>,
        values: [
          { value: 'darkbrown', text: 'Dark Brown'},
          { value: 'brown', text: 'Brown'},
          { value: 'auburn', text: 'Auburn'},
          { value: 'chestnut', text: 'Chestnut'},
          { value: 'hazel', text: 'Hazel'},
          { value: 'red', text: 'Red'},
          { value: 'blonde', text: 'Blonde'},
          { value: 'black', text: 'Black'},
          { value: 'grey', text: 'Grey'},
        ],
      },
      {
        id: 'lipshape',
        question: <>How would you describe the shape of their <strong>lips</strong>?</>,
        values: [
          { value: 'thin', text: 'Thin'},
          { value: 'oval', text: 'Oval'},
          { value: 'downturned', text: 'Down Turned'},
          { value: 'small', text: 'Small'},
          { value: 'largefull', text: 'Large Full'},
          { value: 'sharp', text: 'Sharp'},
        ],
      },
      {
        id: 'eyeshape',
        question: <>How would you describe their <strong>eye shape</strong>?</>,
        values: [
          { value: 'almond', text: 'Almond'},
          { value: 'upturned', text: 'Up Turned'},
          { value: 'hooded', text: 'Hooded'},
          { value: 'round', text: 'Round'},
          { value: 'monolid', text: 'Monolid'},
          { value: 'downturned', text: 'Down Turned'},
        ],
      },
      {
        id: 'eyecolor',
        question: <>What is their <strong>eye color</strong>?</>,
        values: [
          { value: 'blue', text: 'Blue'},
          { value: 'darkbrown', text: 'Dark Brown'},
          { value: 'brown', text: 'Brown'},
          { value: 'hazel', text: 'Hazel'},
          { value: 'amber', text: 'Amber'},
          { value: 'grey', text: 'Grey'},
        ],
      },
    ]
  },
];
